import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../colorVars';

export const AskLine = ({ dataArray, scaleX, scaleY }) => {
  if (scaleY == null || scaleX === null || dataArray.length < 2) return null;
  return (
    <g stroke={colors.red}>
      {dataArray.map((item, index) => {
        if (index === 0) return null;
        const previousPrice = scaleY(dataArray[index - 1].ask);
        const currentPrice = scaleY(item.ask);
        return (
          <line
            key={'' + index + item}
            x1={scaleX(index - 1)}
            x2={scaleX(index)}
            y1={previousPrice}
            y2={currentPrice}
          />
        );
      })}
    </g>
  );
};

AskLine.propTypes = {
  dataArray: PropTypes.array,
  scaleX: PropTypes.func,
  scaleY: PropTypes.func
};
